module.exports = {
      id: "author-avator-usage",
      viewBox: "0 0 102 102",
      url: "/" + "sprite-d3510a915c790cce9510dd41eb326371.svg#author-avator",
      toString: function () {
        return this.url;
      }
    }